import { Col, Row } from "react-bootstrap";
import useUserRole from "../../../../hooks/useUserRole";
import { UserRole } from "../../../../utils";
import IconHome from "../../../../styles/icons/IconHome";

interface WelcomeSectionProps {
  performance?: number;
}

const getPerformanceLabel = (rate: number): React.ReactNode => {
  switch (rate) {
    case 1:
      return (
        <div className="chip chip--soft chip--status-top">Top Performer</div>
      );

    case 2:
      return <div className="chip chip--soft chip--status-good">On Track</div>;

    case 3:
      return (
        <div className="chip chip--soft chip--status-below">
          Needs Attention
        </div>
      );

    default:
      return (
        <div className="chip chip--soft chip--status-below">
          Needs Attention
        </div>
      );
  }
};

const WelcomeSection = ({ performance }: WelcomeSectionProps) => {
  const currentUserRole = useUserRole();

  const TodayDate = () => {
    const today = new Date();

    const formattedDate = today.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    return (
      <div className="current-date">
        <IconHome breadcrumb="calendarIcon" />
        {formattedDate}
      </div>
    );
  };

  const getWelcomeMessage = () => {
    switch (currentUserRole) {
      case "Operator":
        return (
          <div className="welcome-section">
            <h1>
              Call Console - <span>Operator</span>
            </h1>
            <p>Capture conversations. We handle the rest.</p>
          </div>
        );
      case "Customer":
        return (
          <div className="welcome-section">
            <h1>
              Lead Intelligence - <span>Customer</span>
            </h1>
            <p>Al-powered lead decisions and next actions.</p>
          </div>
        );
      default:
        return (
          <div className="welcome-section">
            <h1>
              Control Centre -{" "}
              <span>
                {currentUserRole === UserRole.GlobalAdmin ? "Global Admin" : "Admin"}
              </span>
            </h1>
            <p>Monitor performance and outcomes in real time.</p>
          </div>
        );
    }
  };

  return (
    <Row>
      <Col sm={9}>{getWelcomeMessage()}</Col>
      <Col sm={3}>
        <div className="performace-label">
          <div>{TodayDate()}</div>
        </div>
      </Col>
    </Row>
  );
};

export default WelcomeSection;
